import Template from "./PumpkinDetails.ejs";
import Element from "../../Utils/Element";

export default class PumpkinDetails extends Element {
    constructor(data) {
        super();
        this.data = data;
        this.element.classList.add("PumpkinOverlay");
        this.element.classList.add(data.key);
        this.element.classList.add("hide");
        this.element.innerHTML = Template(data);
        this.closeButton = this.element.getElementsByClassName("back")[0];
        this.clicked = ()=>{this.close()};
        this.closeButton.addEventListener("click", this.clicked);
        ga('send', 'Show Pumpkin Details', data.Name);
    }

    show() {
        this.element.classList.add("show");
        this.element.classList.remove("hide");
    }
    hide() {
        this.element.classList.add("hide");
        this.element.classList.remove("show");
    }
    close() {
        this.closeButton.removeEventListener("click", this.clicked);
        this.hide();
        setTimeout(this.destroy.bind(this), 1000);
    }
}


// WEBPACK FOOTER //
// ./src/views/Components/PumpkinDetails.js